export const COLLAPSED_BODY_LINES = 3;
export const BODY_HEIGHT_TOLERANCE = 1;
